export const DifferentData = {
    listTitle: "What separates us from other San Francisco digital agencies is that we are not one. We are:",
    listContent: [
        'Smaller than the expensive horde of project managers, "researchers", scrum masters, foosball players, etc.',
        'Based in San Francisco. No more midnight zooms to the other side of the globe.',
        'Open during burning man. All about peace, love, happiness and joy to the world.'
    ]
}